import { Component, inject } from '@angular/core';
import { ToasterService } from "./toaster.service";
import { Observable } from "rxjs";

@Component({
    selector: 'toaster-host',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
    standalone: false
})
export class ToasterComponent {
  private readonly toasterService = inject(ToasterService);


  toasts$: Observable<any>;

  constructor() {
    this.toasts$ = this.toasterService.toasts$;
  }

}
